import {Component, Input} from "@angular/core";
@Component({
  selector: 'app-modal',
  template: `
  <div class="modal fade" tabindex="-1" [ngClass]="{'in': visibleAnimate}" [attr.data-backdrop]="false"
       [ngStyle]="{'display': visible ? 'block' : 'none', 'opacity': visibleAnimate ? 1 : 0}">
    <div class="modal-dialog" [ngClass]="cssClass">
      <div class="modal-content" id="model-content">
        <div class="modal-header">
          <ng-content select=".app-modal-header"></ng-content>
        </div>
        <div class="modal-body">
          <ng-content select=".app-modal-body"></ng-content>
        </div>
        <div class="modal-footer">
          <ng-content select=".app-modal-footer"></ng-content>
        </div>
      </div>
    </div>
  </div>
  `,
  styleUrls:['./modal.scss']
})
export class AppModalComponent {

   visible = false;
   visibleAnimate = false;
  @Input() cssClass?:string

  public open(): void {
    this.visible = true;
    setTimeout(() => this.visibleAnimate = true);
  }

  public hide(): void {
    this.visibleAnimate = false;
    setTimeout(() => this.visible = false, 300);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/modal/modal.ts